import * as tslib_1 from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { AssistanceMethods } from '@/help.search';
let ParkAccessDetails = class ParkAccessDetails extends Vue {
    get entranceHeightText() {
        return `Entrance Height ${this.data.entranceHeight} m`;
    }
    get waitTimeTitle() {
        return `Wait Time ${this.data.waitTimeMins} mins`;
    }
    get waitTimeText() {
        return `Wait Time <nobr>${this.data.waitTimeMins} mins</nobr>`;
    }
    get appUrlTitle() {
        return `Request Assistance on the '${this.data.appName}' App`;
    }
    get websiteUrlTitle() {
        return `Request Assistance on the '${this.data.appName}' Website`;
    }
    get showRequestAssistanceActions() {
        if (this.data.assistanceMethods != null) {
            var valAsString = AssistanceMethods[AssistanceMethods.AppOrWebsite];
            return this.data.assistanceMethods.includes(valAsString); //we have to turn the enum value AssistanceMethods.AppOrWebsite (a number) into a string to compare it with the list of strings here, need as any to stop TS complaining at runtime !
        }
        return false;
    }
};
tslib_1.__decorate([
    Prop()
], ParkAccessDetails.prototype, "data", void 0);
ParkAccessDetails = tslib_1.__decorate([
    Component
], ParkAccessDetails);
export default ParkAccessDetails;
